import {
  axiosSysApi
} from '../../axios_init'

import {
  saveData,
  delData
} from '../../api/local_storage'

const state = {
  source_data_field: {
    shop: {
      shop: '城市',
      dry: '干货',
      Fresh: '新鲜货',
      frozen: ' 冰冻货'
    },
    oil: {
      shop: '加油站',
      dry: '0号柴油',
      Fresh: '92号汽油',
      frozen: '95号汽油'
    },
    tobacco: {
      shop: '商店',
      dry: '红塔山',
      Fresh: '玉溪',
      frozen: '云烟'
    }
  },
  source_data_type: 'shop',
  source_data: {},
  order_weight: [],
  order_volume: [],
  order_days: [],
  shop_coordinate: {}
}

const getters = {
  sourceDataField: state => state.source_data_field,
  sourceDataType: state => state.source_data_type,
  sourceData: state => state.source_data,
  orderWeight: state => state.order_weight,
  orderVolume: state => state.order_volume,
  orderDays: state => state.order_days,
  shopCoordinate: state => state.shop_coordinate
}

const actions = {
  setSourceDataType ({ commit }, data) {
    commit('changeSourceDataType', data)
  },
  editSourceData ({ commit, getters }, data) {
    // commit('editCustomerSourceData', data)
    // dispatch('initCustomerData', getters.sourceData)
  },
  initCustomerData ({ commit, dispatch, getters }, data) {
    // 订单重量
    let orderWeight = []
    // 订单体积
    let orderVolume = []
    // 客户地图数据
    let mapDataCustomer = []
    data.Location.forEach(function (item) {
      orderWeight.push({'shop': item[0], 'dry': item[3], 'Fresh': item[4], 'frozen': item[5]})
      orderVolume.push({'shop': item[0], 'dry': item[6], 'Fresh': item[7], 'frozen': item[8]})
      mapDataCustomer.push({
        'name': item[0],
        'value': [item[1], item[2], {'dry': item[3], 'fresh': item[4], 'frozen': item[5]}, {'dry': item[6], 'fresh': item[7], 'frozen': item[8]}]
      })
    })
    // 中心点座标
    dispatch('setOrderWeight', orderWeight)
    dispatch('setOrderVolume', orderVolume)
    // 中心点地图数据
    data.OrderDays.forEach(function (item) {
      let workDats = []
      item.forEach(function (value, index) {
        if (value === 1) {
          workDats.push(index - 1)
        }
      })
      mapDataCustomer.forEach(function (itemC) {
        if (itemC.name === item[0]) {
          itemC['order_days'] = workDats
        }
      })
    })
    dispatch('setMapDataCustomer', mapDataCustomer)
    dispatch('setAllMapDataCustomer', mapDataCustomer)
  },
  initSourceData ({ commit, dispatch, getters }, data) {
    if (data === 'clear' || !data.Location) {
      commit('changeSourceData', {})
      dispatch('setOrderWeight', [])
      dispatch('setOrderVolume', [])
      dispatch('setShopCoordinate', [])
      dispatch('setMapDataPlant', [])
      dispatch('setMapDataCustomer', [])
      dispatch('setOrderDays', [])
      dispatch('setSolutionStatus', 0)
    } else {
      dispatch('setSourceData', data)
    }
  },
  setSourceData ({ commit, dispatch, getters }, data) {
    commit('changeSourceData', data)
    // 订单重量
    let orderWeight = []
    // 订单体积
    let orderVolume = []
    // 店铺座标
    let shopCoordinate = {}
    // 客户地图数据
    let mapDataCustomer = []
    // 订货时间
    let orderDays = []
    data.Location.forEach(function (item) {
      orderWeight.push({'shop': item[0], 'dry': item[3], 'Fresh': item[4], 'frozen': item[5]})
      orderVolume.push({'shop': item[0], 'dry': item[6], 'Fresh': item[7], 'frozen': item[8]})
      shopCoordinate[String(item[0])] = [item[1], item[2]]
      mapDataCustomer.push({
        'name': item[0],
        'value': [item[1], item[2], {'dry': item[3], 'fresh': item[4], 'frozen': item[5]}, {'dry': item[6], 'fresh': item[7], 'frozen': item[8]}]
      })
    })
    // 中心点座标
    shopCoordinate[data.Plant[0][0]] = [data.Plant[0][1], data.Plant[0][2]]
    dispatch('setOrderWeight', orderWeight)
    dispatch('setOrderVolume', orderVolume)
    dispatch('setShopCoordinate', shopCoordinate)
    // 中心点地图数据
    dispatch('setMapDataPlant', [{name: data.Plant[0][0], value: [data.Plant[0][1], data.Plant[0][2]]}])
    data.OrderDays.forEach(function (item) {
      let workDats = []
      item.forEach(function (value, index) {
        if (value === 1) {
          workDats.push(index - 1)
        }
      })
      orderDays.push({'shop': item[0], 'order_days': workDats})
      mapDataCustomer.forEach(function (itemC) {
        if (itemC.name === item[0]) {
          itemC['order_days'] = workDats
        }
      })
    })
    dispatch('setMapDataCustomer', mapDataCustomer)
    dispatch('setAllMapDataCustomer', mapDataCustomer)
    dispatch('setOrderDays', orderDays)
    dispatch('setSolutionStatus', 10)
  },
  saveSourceData ({ commit }, data) {
    commit('saveSourceData', data)
  },
  clearSourceData ({ commit }, data) {
    delData('source_data' + data)
  },
  setOrderWeight ({ commit }, data) {
    commit('changeOrderWeight', data)
  },
  setOrderVolume ({ commit }, data) {
    commit('changeOrderVolume', data)
  },
  setOrderDays ({ commit }, data) {
    commit('changeOrderDays', data)
  },
  setShopCoordinate ({ commit }, data) {
    commit('changeShopCoordinate', data)
  },
  loadSourceData ({commit, dispatch}, path) {
    dispatch('setLoading', true)
    dispatch('setLoadingText', '加载数据中')
    dispatch('setPercentage', {'start': 0, 'next': 80})
    axiosSysApi.get('/static/' + path).then(function (response) {
      dispatch('setLoadingText', '解析数据中')
      dispatch('setPercentage', {'start': 80, 'next': 100})
      dispatch('setSourceData', response.data)
      dispatch('setLoadingText', '解析数据完成')
      dispatch('setPercentage', {'start': 100, 'next': 100})
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '导入数据异常',
        message: '错误信息:' + e
      })
      dispatch('setLoadingText', '导入数据异常')
      dispatch('setPercentage', {'start': 100, 'next': 100})
    })
  }
}

const mutations = {
  editCustomerSourceData (state, data) {
  },
  changeSourceData (state, data) {
    state.source_data = data
  },
  changeSourceDataType (state, data) {
    state.source_data_type = data
  },
  changeOrderWeight (state, data) {
    state.order_weight = data
  },
  changeOrderVolume (state, data) {
    state.order_volume = data
  },
  changeOrderDays (state, data) {
    state.order_days = data
  },
  changeShopCoordinate (state, data) {
    state.shop_coordinate = data
  },
  saveSourceData (state, data) {
    saveData({key: 'source_data' + data, data: state.source_data})
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/source_data.js